(function ($) {
    $(document).ready(function () {
        var slideSingle = $('.post-detail .slider-wrapper .image-wrap').length;
        $('.post-detail .slider-wrapper').slick({
            draggable: true,
            arrows: false,
            dots: true,
            fade: true,
            speed: 900,
            dotsClass: 'custom-dots',
            infinite: true,
            autoplay: true,
            adaptiveHeight: true,
            cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        });

        $('body .post-detail .content-outer .slider-wrapper .image-wrap a').click(function (e) {
            e.preventDefault();
            var videolink = $(this).attr('href');

            $('.we-video-overlay').addClass('overlay-active');
            $('body .video-overlay iframe').attr("src", videolink);
        })

    });
    $(window).on("load resize",function () {
        var slideSingle = $('.post-detail .slider-wrapper .image-wrap').length;
        if (slideSingle <= 1) {
            $('.post-detail .slider-wrapper .custom-dots').hide();
        } else {
            $('.post-detail .slider-wrapper .custom-dots').show();
        }
    });
})(jQuery);